import React from 'react';
import Icon from '@/components/ui/AppIcon';

const logs = [
  { id: 'log-001', action: 'Créateur vérifié', detail: 'Yasmine Belkacem — profil approuvé', user: 'Admin Riad', time: '18 Aoû · 19:12', type: 'success' },
  { id: 'log-002', action: 'Campagne créée', detail: 'Galaxy S26 Launch — Samsung Algérie', user: 'Admin Riad', time: '18 Aoû · 18:30', type: 'info' },
  { id: 'log-003', action: 'Vérification refusée', detail: 'Profil incomplet — docs manquants', user: 'Admin Sara', time: '18 Aoû · 16:45', type: 'warning' },
  { id: 'log-004', action: 'Compte marque créé', detail: 'Garnier DZ — accès activé', user: 'Admin Riad', time: '18 Aoû · 14:20', type: 'info' },
  { id: 'log-005', action: 'Momentum Score mis à jour', detail: 'Lina Meziane — 88 → 91', user: 'Système', time: '18 Aoû · 12:00', type: 'neutral' },
  { id: 'log-006', action: 'Créateur mis en pause', detail: 'Rania Touati — raison: indisponibilité', user: 'Admin Sara', time: '17 Aoû · 17:30', type: 'warning' },
  { id: 'log-007', action: 'Certification validée', detail: 'Amel Bensalem — CPP 72H · Score 89/100', user: 'Admin Riad', time: '16 Aoû · 11:15', type: 'success' },
  { id: 'log-008', action: 'Portfolio mis à jour', detail: 'Karim Oussedik — 3 nouveaux travaux', user: 'Système', time: '15 Aoû · 09:40', type: 'neutral' },
  { id: 'log-009', action: 'Campagne terminée', detail: 'Ramadan 2026 — L\'Oréal Paris DZ', user: 'Système', time: '10 Avr · 23:59', type: 'success' },
  { id: 'log-010', action: 'Alerte délai', detail: 'Back to School — 0 créateur confirmé', user: 'Système', time: '17 Aoû · 08:00', type: 'warning' },
];

const typeConfig = {
  success: { icon: 'CheckCircleIcon', color: 'text-positive bg-positive/10' },
  info: { icon: 'InformationCircleIcon', color: 'text-info bg-info/10' },
  warning: { icon: 'ExclamationTriangleIcon', color: 'text-warning bg-warning/10' },
  neutral: { icon: 'ArrowPathIcon', color: 'text-muted-foreground bg-muted' },
};

export default function AdminActivityLog() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-700 text-foreground">Journal d'activité</h3>
        <button className="text-xs text-muted-foreground hover:text-foreground transition-colors">
          Voir tout
        </button>
      </div>
      <div className="space-y-3">
        {logs.map((log) => {
          const cfg = typeConfig[log.type as keyof typeof typeConfig];
          return (
            <div key={log.id} className="flex items-start gap-3">
              <div className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${cfg.color}`}>
                <Icon name={cfg.icon as Parameters<typeof Icon>[0]['name']} size={13} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-700 text-foreground">{log.action}</p>
                <p className="text-xs text-muted-foreground mt-0.5 line-clamp-1">{log.detail}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-muted-foreground/60">{log.user}</span>
                  <span className="text-xs text-muted-foreground/40">·</span>
                  <span className="text-xs text-muted-foreground/60">{log.time}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}